import { useEffect, useState } from "react";
import { IPlatform } from "../entity/platforms/IPlatform";
import { updateForceUpdateUseCase } from "../useCases/updateForceUpdateUseCase";
import { getForceUpdateUseCase } from "../useCases/getForceUpdateUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";
import { prepareRequestBody } from "./prepareRequestBody";

export const useForceUpdateTableItem = (item: IPlatform) => {
    const { t } = useUiContext();
    const [platform, setPlatform] = useState(item);

    useEffect(() => {
        setPlatform(item);
    }, [item]);

    const onChange = (value: any, field: string) => {
        setPlatform(prev => ({ ...prev, [field]: value }));
    };

    const onChangeMininalVersion = (value: any) => {
        const filteredValue = value.replace(/[^0-9.]/g, '');
        onChange(filteredValue, 'minimal_version');
    };

    const onChangeRecommendedVersion = (value: any) => {
        const filteredValue = value.replace(/[^0-9.]/g, '');
        onChange(filteredValue, 'recommended_version');
    };

    const onChangeLink = (value: any) => {
        onChange(value, 'link');
    };

    const handleBlur = async () => {
        const body = prepareRequestBody(platform);
        if (JSON.stringify(item) !== JSON.stringify(platform)) {
            const res = await updateForceUpdateUseCase(body);
            if (!res?.isError) {
                toastService.onSuccess(t('force_update.data_updated'));
                await getForceUpdateUseCase();
            }
        }
    };

    return { onChangeMininalVersion, onChangeRecommendedVersion, platform, handleBlur, onChangeLink }
};